var _defs, _g, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutUxFlowchartVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 500",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow-coral",
    viewBox: "0 0 10 10",
    refX: 6,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 1 L 10 5 L 0 9 z",
    fill: "#ED8F6D"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow-green",
    viewBox: "0 0 10 10",
    refX: 6,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 1 L 10 5 L 0 9 z",
    fill: "#22C55E"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 140 60 Q 200 60 220 120",
    fill: "none",
    stroke: "#ED8F6D",
    strokeWidth: 2.5,
    strokeDasharray: "5 4",
    markerEnd: "url(#arrow-coral)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 140 440 Q 200 440 230 380",
    fill: "none",
    stroke: "#ED8F6D",
    strokeWidth: 2.5,
    strokeDasharray: "5 4",
    markerEnd: "url(#arrow-coral)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 380 120 Q 420 60 480 60",
    fill: "none",
    stroke: "#22C55E",
    strokeWidth: 2.5,
    markerEnd: "url(#arrow-green)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 380 380 Q 420 440 460 440",
    fill: "none",
    stroke: "#5D81A9",
    strokeWidth: 2.5,
    markerEnd: "url(#arrow-coral)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 120,
    r: 4,
    fill: "#ED8F6D"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;1;0.2",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 60,
    r: 4,
    fill: "#22C55E"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;1;0.2",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUxFlowchartVector);
export default __webpack_public_path__ + "static/media/about-ux-flowchart-vector.bf6e928a7ca5981cbc05d91799701922.svg";
export { ForwardRef as ReactComponent };